import { Rest } from './rest'

const headers = ({ token }) => {
  return { Authorization: `Bearer ${token}` }
}
const Network = new Rest(process.env.REACT_APP_NETWORK, headers)

export default Network
